import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import Chart from 'highcharts-react-official'
import { formatNumberWithThousandSeparator } from '../../modules/utils/formatters'
import highchartsBaseInstance from './highchartsBaseInstance'
import { GlobalStyle } from './ColumnsChart.styles'

/**
 * The ColumnChart's component.
 */
const ColumnChart = props => {
  const theme = useTheme()
  const {
    categories: { months, monthsShort },
    data,
    tickScale
  } = props

  const options = {
    chart: {
      animation: false,
      height: 350,
      type: 'column',
      margin: [10, 2, 90, 65],
      spacingLeft: 0,
      style: {
        fontFamily: 'Roboto',
        fontSize: '12px',
        fontWeight: '400'
      }
    },
    accessibility: {
      enabled: true
    },
    title: {
      text: ''
    },
    series: data,
    yAxis: {
      title: { text: '' },
      accessibility: {
        description: 'Montos en Millones de pesos'
      },
      tickPositions: tickScale,
      lineWidth: 1,
      tickWidth: 1,
      tickLength: 5,
      startOnTick: true,
      endOnTick: true,
      labels: {
        style: {
          color: theme.palette.brand.black1
        },
        formatter: function () {
          const valueInMillions = this.value / 1e6
          return `${formatNumberWithThousandSeparator(valueInMillions)} M`
        }
      }
    },
    xAxis: {
      categories: months,
      endOnTick: true,
      gridLineDashStyle: 'ShortDash',
      gridLineWidth: 1,
      min: 0,
      startOnTick: false,
      accessibility: {
        description: 'Monto planificado y ejecutado por cada mes'
      },
      labels: {
        style: {
          color: theme.palette.brand.black1
        }
      }
    },
    tooltip: {
      headerFormat: '<b>{point.key}</b><br/>',
      pointFormatter: function () {
        const valueInMillions = this.y / 1e6
        return `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${formatNumberWithThousandSeparator(Math.round(valueInMillions))} M</b><br/>`
      },
      shared: false
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 550
          },
          chartOptions: {
            xAxis: {
              categories: monthsShort
            }
          }
        }
      ]
    }
  }

  return (
    <>
      <GlobalStyle />
      <Chart highcharts={highchartsBaseInstance} options={options} />
    </>
  )
}

ColumnChart.defaultProps = {
  id: 'columnChart'
}

ColumnChart.propTypes = {
  categories: PropTypes.shape({
    months: PropTypes.arrayOf(PropTypes.string),
    monthsShort: PropTypes.arrayOf(PropTypes.string)
  }),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      data: PropTypes.arrayOf(PropTypes.number),
      name: PropTypes.string,
      footer: PropTypes.string
    })
  ),
  tickScale: PropTypes.arrayOf(PropTypes.number)
}

export default ColumnChart
